export default __webpack_public_path__ + "static/media/founderibc.cb4ef4b8.png";